import React from 'react'

const PrivacyPolicyComponent = () => {
  return (
    <div>


        <div className="privacy-policy-component">
            
        
        <h1>Privacy Policy</h1>

        <p>This Privacy Policy explains how the company collects, uses, and shares your personal data when you use their service, and outlines your privacy rights. By using the service, you consent to the collection and use of your information as described.</p>

        <h3>Key Terms:</h3>

        <li><b>Company:</b> BhumuCompany, Delhi NCR, India</li>
        <li><b>Personal Data:</b> Information that identifies you, such as name, email, phone number, and address.</li>
        <li><b>Usage Data:</b> Data collected automatically, like IP address, browser type, and device information.</li>
        <li><b>Service:</b> The website accessible at https://bhumucompany.com/</li>

        <h3>Types of Data Collected:</h3>

        <li><b>Personal Data:</b> Includes email, phone number, name, address, etc.</li>
        <li><b>Usage Data:</b> Includes automatically collected data such as IP address, device type, and pages visited.</li>
        <li><b>Cookies and Tracking:</b> The site uses cookies to track user activity. You can adjust your browser settings to refuse cookies.</li>

        <h3>Use of Data:</h3>

        <li>To provide and improve the service</li>
        <li>To manage your account and communications</li>
        <li>For marketing and business transfers</li>
        <li>To analyze usage trends and improve the service</li>

        <h3>Data Sharing:</h3>

        <li><b>Service Providers: </b>Shared with third-party providers for processing.</li>
        <li><b>Business Transfers: </b>Shared during mergers or acquisitions.</li>
        <li><b>Affiliates and Partners:</b> Shared with affiliates or business partners for promotions.</li>
        <li><b>With Your Consent:</b> Shared with your approval.</li>

        <h3>Retention and Transfer of Data:</h3>

        <li>Data will be retained as long as necessary to fulfill the purposes outlined.</li>
        <li>Data may be transferred to locations outside your jurisdiction with appropriate security measures.</li>

        <h3>Your Rights:</h3>


        <li>You can update, amend, or delete your personal information.</li>
        <li>You have the right to request the deletion of your data.</li>

        <h3>Data Security:</h3>

        <li>While reasonable security measures are taken, no method is completely secure.</li>

        <h3>Children's Privacy:</h3>
        <li>The service is not for individuals under 13 years old. No personal data is knowingly collected from children under 13.</li>

        
        <h3>Third-Party Links:</h3>
        <li>The service may contain links to external websites. The company is not responsible for their content or privacy practices.</li>

        <h3>Changes:</h3>
        <li>The privacy policy may be updated periodically, and changes will be posted with a notification.</li>

        <h3>Contact:</h3>
        <li>For questions about the privacy policy, contact the company at info@bhumucompany.com</li>





    </div>

        
        
    </div>
  )
}

export default PrivacyPolicyComponent